import { Map, APIProvider } from "@vis.gl/react-google-maps";

export function GoogleMapsApiProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <APIProvider
      apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
      libraries={["geometry"]}
    >
      <Map
        zoom={13}
        center={{ lat: 43.6532, lng: -79.3832 }}
        mapId={"3667d2e0a1e93d2b"}
      >
        {children}
      </Map>
    </APIProvider>
  );
}
